import { Button } from '@/components/originui/button';
import { Hourglass } from 'lucide-react';

type TransactionExpiredProps = {
  reset: () => void;
};

export function TransactionExpired({ reset }: TransactionExpiredProps) {
  return (
    <>
      <Hourglass size={64} color="orange" aria-hidden />

      <h3 className="text-xl leading-relaxed font-semibold">BankID-Verifiering tog för lång tid</h3>

      <Button variant={'outline'} onClick={reset}>
        Försök igen
      </Button>
    </>
  );
}
